module.exports = __webpack_public_path__ + "static/img/logo03.01349613.png";